import(/* webpackMode: "eager", webpackExports: ["GameTemplate"] */ "/vercel/path0/src/components/GameTemplate/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeLayout"] */ "/vercel/path0/src/components/Layouts/HomeLayout.tsx");
